import { type QuestionProperties } from '../../types';

export function getTotalQuestionCount(input: QuestionProperties) {
  const calculateTotal = Object.values(input.calculate ?? {}).reduce((sum: number, count) => {
    return sum + (count ? count : 0);
  }, 0);

  const nonCalculateTotal = Object.values(input.nonCalculate ?? {}).reduce((sum: number, count) => {
    return sum + (count ? count : 0);
  }, 0);

  return calculateTotal + nonCalculateTotal;
}
